import * as InsLoginApi from "@/api/ins/private/ins_login";
import {
  INS_RESPONSE_ERROR_MSG,
  INS_LOGIN_MSG,
  statusRes,
  INS_LOGIN_NEED_CREATE_ACCOUNT_ERROR,
  insLoginErrorResolve,
  INS_UNCAUGHT_ERROR,
  INS_CHALLENG_STEP_NAME
} from "@/api/ins/base/ins_res_const";
import {
  ins_login,
  fxcalSsoLogin,
  fxcalSsoAccount
} from "@/api/ins_api_new/apis/ins_login";

import { getChallenge } from "@/api/ins_api_new/apis/ins_challenge";
import CGAPIBcloksPayload from "@/api/ins_api_new/utils/challenge_helper/block_payload";
import { bloksApps } from "@/api/ins_api_new/apis/ins_challenge";

interface InsLoginParams {
  username?: string;
  password?: string;
  fbToken?: string;
}

const handleChallengeInfo = async (info: any) => {
  CGAPIBcloksPayload.setChallengeInfo(info);
  try {
    // 遇到challege,先调用一次blokapp方法
    await bloksApps({ ...info, get_challenge: true });
    console.log("handleChallengeInfo");
    return { data: info, status: INS_LOGIN_MSG.INS_LOGIN_CHALLENGE_VERIFY };
  } catch (error) {
    console.log("handleChallengeInfo error", error);
    return Promise.reject(error);
  }
};

export const handleChallenge = async (challenge: any) => {
  try {
    const challengeInfo = await getChallenge(challenge);
    console.log("challengeInfo", challengeInfo);

    return await handleChallengeInfo(challengeInfo);
  } catch (error) {
    console.log("loginErrorCommonResolve error", error);
    if (error && error.status === INS_RESPONSE_ERROR_MSG.CHALLENGE_REQUIRED) {
      return error;
    }
    return Promise.reject(insLoginErrorResolve(error));
  }
};

export const loginErrorCommonResolve = async (error: any) => {
  try {
    const {
      status,
      error_type,
      message,
      challenge,
      two_factor_required,
      two_factor_info
    } = error;
    if (status && status === "fail") {
      if (
        error_type === INS_RESPONSE_ERROR_MSG.CHECKPOINT_CHALLENGE_REQUIRED ||
        message === INS_RESPONSE_ERROR_MSG.CHALLENGE_REQUIRED
      ) {
        // challenge 验证
        return await handleChallenge(challenge);
      } else if (
        error_type === INS_RESPONSE_ERROR_MSG.RATE_LIMIT &&
        two_factor_required
      ) {
        // 登陆双重验证太频繁 触发了limit,必须在two_factor_required前面判断，因为此时也有two_factor_required为true
        return statusRes(INS_LOGIN_MSG.INS_LOGIN_TWO_FACTOR, two_factor_info);
      } else if (two_factor_required) {
        //  需要两步验证
        return statusRes(INS_LOGIN_MSG.INS_LOGIN_TWO_FACTOR, two_factor_info);
      } else if (
        error_type === INS_RESPONSE_ERROR_MSG.CHECKPOINT_LOGGED_OUT &&
        message === INS_RESPONSE_ERROR_MSG.CHECKPOINT_REQUIRED
      ) {
        // 未知错误显示
        return Promise.reject(INS_UNCAUGHT_ERROR);
      } else {
        // 密码错误之类的
        return Promise.reject(
          statusRes(INS_LOGIN_MSG.INS_LOGIN_OTHER_FAILURE, error)
        );
      }
    }
    return Promise.reject(insLoginErrorResolve(error));
  } catch (syncError) {
    console.log("loginErrorCommonResolve syncError", syncError);
    return Promise.reject(insLoginErrorResolve(syncError));
  }
};

/**
 * Fetch Chanllenge
 * @param challengeMeta
 */
export const insChallengeFetch = async (challengeMeta: any) => {
  try {
    const challengeUrl = challengeMeta.url;
    const challengeData: any = await InsLoginApi.fetchChallenge(challengeUrl);
    console.log("challengeData", challengeData);
    const { step_name: stepName }: any = challengeData;
    if (INS_CHALLENG_STEP_NAME.DELTA_LOGIN_REVIEW === stepName) {
      // 是否本人？=>直接验证为是本人
      const deltaLoginResult: any = await InsLoginApi.sendChallenge(
        challengeUrl,
        "0"
      );
      if (deltaLoginResult && deltaLoginResult.ok) {
        return statusRes(INS_LOGIN_MSG.INS_LOGIN_FAILURE_DELTA, "try again!");
      } else {
        return Promise.reject(INS_UNCAUGHT_ERROR);
      }
    } else if (INS_CHALLENG_STEP_NAME.SELECT_VERIFY_METHOD === stepName) {
      return statusRes(INS_LOGIN_MSG.INS_LOGIN_CHALLENGE, {
        ...challengeData,
        challenge_url: challengeUrl
      });
    } else if (
      INS_CHALLENG_STEP_NAME.VERIFY_PHONE_NUMBER === stepName ||
      INS_CHALLENG_STEP_NAME.VERIFY_CODE === stepName ||
      INS_CHALLENG_STEP_NAME.VERIFY_EMAIL === stepName
    ) {
      // 直接出发了verify
      return statusRes(INS_LOGIN_MSG.INS_LOGIN_CHALLENGE_VERIFY, {
        ...challengeData,
        challenge_url: challengeUrl,
        selected_choice:
          INS_CHALLENG_STEP_NAME.VERIFY_EMAIL === stepName ? "1" : "0"
      });
    } else {
      // 当状态不是 INS_CHALLENG_STEP_NAME 中的任何一种时，不作处理，只给提示
      return Promise.reject(INS_UNCAUGHT_ERROR);
    }
  } catch (error) {
    if (error && error.message === INS_RESPONSE_ERROR_MSG.CHALLENGE_REQUIRED) {
      return Promise.reject({
        status: INS_RESPONSE_ERROR_MSG.CHALLENGE_REQUIRED
      });
    }
    return Promise.reject(insLoginErrorResolve(error));
  }
};

const fbLoginInfo = async (token: string = "") => {
  try {
    const result = await fxcalSsoAccount(token);
    const userInfo = await fxcalSsoLogin(result, token);
    console.log("fbLoginInfo userInfo", userInfo);
    return userInfo;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Login fb or ins
 * @param param0
 */
export const insLogin = async ({
  username,
  password,
  fbToken
}: InsLoginParams) => {
  try {
    const { logged_in_user, account_created }: any =
      username && password
        ? await ins_login(username, password)
        : await fbLoginInfo(fbToken);
    // fb的登陆可能返回没有注册过ins用户
    if (!logged_in_user && account_created === false) {
      // fb
      return Promise.reject(INS_LOGIN_NEED_CREATE_ACCOUNT_ERROR);
    }
    return statusRes(INS_LOGIN_MSG.INS_LOGIN_SUCCESS, logged_in_user);
  } catch (error) {
    console.log("insLogin error:", error);
    const errorRes = await loginErrorCommonResolve(error);
    return errorRes;
  }
};
